<template>
  <div>
    <div
      class="label-editor-toolbar"
      @mousedown.capture="handleToolbarMouseDown"
      @focusin.capture="preserveEditorSelection"
    >
      <div class="toolbar-section toolbar-section-labeled">
        <span class="toolbar-label">Fonte</span>
        <el-button onlyIcon title="Negrito" @click.prevent="applyTextFormat('bold')">
          <strong class="toolbar-symbol">B</strong>
        </el-button>
        <el-button onlyIcon title="Itálico" @click.prevent="applyTextFormat('italic')">
          <em class="toolbar-symbol">I</em>
        </el-button>
        <el-button onlyIcon title="Sublinhado" @click.prevent="applyTextFormat('underline')">
          <span class="toolbar-symbol toolbar-underline">U</span>
        </el-button>
        <el-button onlyIcon title="Tachado" @click.prevent="applyTextFormat('strikeThrough')">
          <span class="toolbar-symbol toolbar-strike">S</span>
        </el-button>
        <el-input
          v-model="fontSize"
          class="toolbar-number-input"
          type="number"
          min="4"
          max="72"
          step="1"
          size="mini"
          @change="selectFontSize(fontSize)"
        ></el-input>
        <el-dropdown
          trigger="click"
          @visible-change="preserveEditorSelection"
          @command="selectFontName"
        >
          <el-button title="Família da fonte">
            <i class="el-icon-edit-outline"></i>
            Família
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="Arial">Arial</el-dropdown-item>
              <el-dropdown-item command="Courier New">Courier</el-dropdown-item>
              <el-dropdown-item command="Times New Roman">Times</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div class="toolbar-section toolbar-section-labeled toolbar-color-section">
        <span class="toolbar-label">Cor</span>
        <label class="toolbar-color" title="Cor do texto">
          <i class="el-icon-brush"></i>
          <span>Texto</span>
          <input
            v-model="fontColor"
            type="color"
            @focus="preserveEditorSelection"
            @change="selectFontColor"
          />
        </label>
        <label class="toolbar-color" title="Cor do fundo">
          <i class="el-icon-files"></i>
          <span>Fundo</span>
          <input
            v-model="backgroundColor"
            type="color"
            @focus="preserveEditorSelection"
            @change="selectBackgroundColor"
          />
        </label>
      </div>
      <div class="toolbar-section toolbar-section-labeled">
        <span class="toolbar-label">Layout</span>
        <el-button
          onlyIcon
          title="Alinhar à esquerda"
          @click.prevent="alignText('left')"
        >
          <i class="el-icon-s-fold"></i>
        </el-button>
        <el-button onlyIcon title="Centralizar" @click.prevent="alignText('center')">
          <i class="el-icon-s-operation"></i>
        </el-button>
        <el-button
          onlyIcon
          title="Alinhar à direita"
          @click.prevent="alignText('right')"
        >
          <i class="el-icon-s-unfold"></i>
        </el-button>
        <el-button title="Indentar" @click.prevent="indentText">
          <i class="el-icon-right"></i>
          Indentar
        </el-button>
        <el-dropdown
          trigger="click"
          @visible-change="preserveEditorSelection"
          @command="selectLineHeight"
        >
          <el-button title="Altura da linha">
            <i class="el-icon-sort"></i>
            Linha
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="1">1</el-dropdown-item>
              <el-dropdown-item command="1.15">1.15</el-dropdown-item>
              <el-dropdown-item command="1.5">1.5</el-dropdown-item>
              <el-dropdown-item command="2">2</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-dropdown
          trigger="click"
          @visible-change="preserveEditorSelection"
          @command="selectColumnCount"
        >
          <el-button title="Colunas do layout">
            <i class="el-icon-menu"></i>
            Colunas
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="1">1 coluna</el-dropdown-item>
              <el-dropdown-item command="2">2 colunas</el-dropdown-item>
              <el-dropdown-item command="3">3 colunas</el-dropdown-item>
              <el-dropdown-item command="4">4 colunas</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-button title="Inserir imagem" @click.prevent="selectImage">
          <i class="el-icon-picture"></i>
          Imagem
        </el-button>
      </div>
      <div class="toolbar-section toolbar-section-labeled">
        <span class="toolbar-label">Borda</span>
        <el-dropdown
          trigger="click"
          @visible-change="preserveEditorSelection"
          @command="selectBorderSide"
        >
          <el-button title="Lado da borda">
            <i class="el-icon-crop"></i>
            Lado
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="all">Todos</el-dropdown-item>
              <el-dropdown-item command="top">Superior</el-dropdown-item>
              <el-dropdown-item command="right">Direita</el-dropdown-item>
              <el-dropdown-item command="bottom">Inferior</el-dropdown-item>
              <el-dropdown-item command="left">Esquerda</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-dropdown
          trigger="click"
          @visible-change="preserveEditorSelection"
          @command="selectBorderStyle"
        >
          <el-button title="Estilo da borda">
            <i class="el-icon-minus"></i>
            Estilo
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="solid">Sólida</el-dropdown-item>
              <el-dropdown-item command="dashed">Tracejada</el-dropdown-item>
              <el-dropdown-item command="dotted">Pontilhada</el-dropdown-item>
              <el-dropdown-item command="double">Dupla</el-dropdown-item>
              <el-dropdown-item command="none">Remover</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-input
          v-model="borderWidth"
          class="toolbar-number-input"
          type="number"
          min="0"
          max="12"
          step="1"
          size="mini"
          @change="applyBorderStyle"
        ></el-input>
      </div>
      <div class="toolbar-section toolbar-clear-section">
        <el-button title="Limpar formatação" @click.prevent="format('removeFormat')">
          <i class="el-icon-close"></i>
          Limpar
        </el-button>
      </div>
      <input
        ref="imageInput"
        type="file"
        accept="image/*"
        class="image-input"
        @change="insertImage"
      />
    </div>
    <div ref="editorWrapper" class="label-editor-wrapper">
      <div
        ref="editor"
        class="label-editor"
        contenteditable="true"
        @click="handleEditorClick"
        @input="syncContent"
        @blur="saveEditorSelection"
        @focus="saveEditorSelection"
        @keyup="saveEditorSelection"
        @mouseup="saveEditorSelection"
        @scroll="updateImageResizeBox"
      ></div>
      <div
        v-if="selectedImage"
        class="image-resize-box"
        :style="ImageResizeBoxStyle"
      >
        <span
          class="image-resize-handle"
          title="Redimensionar imagem"
          @mousedown.prevent="startImageResize"
        ></span>
      </div>
    </div>

    <div class="variables-list">
      <div
        v-for="group in variableGroups"
        :key="group.label"
        class="variable-group"
      >
        <span class="variable-group-title">{{ group.label }}</span>
        <el-tag
          v-for="variable in group.variables"
          :key="variable.value"
          :title="variable.value"
          size="mini"
          @mousedown.prevent="insertVariable(variable)"
        >
          {{ variable.label }}
        </el-tag>
      </div>
    </div>
  </div>
</template>

<script>
import { sanitizeTemplate } from "../../utils/labels.js";

export default {
  name: "LabelRichTextEditor",
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    variableGroups: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      fontName: "Arial",
      fontSize: 14,
      fontColor: "#000000",
      backgroundColor: "#ffffff",
      lineHeight: "1",
      columnCount: 1,
      borderSide: "all",
      borderStyle: "solid",
      borderWidth: 1,
      editorSelection: null,
      selectedImage: null,
      imageResizeBox: null,
      imageResizeState: null,
    };
  },
  computed: {
    ImageResizeBoxStyle() {
      if (!this.imageResizeBox) return {};

      return {
        left: `${this.imageResizeBox.left}px`,
        top: `${this.imageResizeBox.top}px`,
        width: `${this.imageResizeBox.width}px`,
        height: `${this.imageResizeBox.height}px`,
      };
    },
  },
  watch: {
    modelValue() {
      this.setEditorHtml();
    },
  },
  mounted() {
    this.setEditorHtml();
    document.addEventListener("selectionchange", this.trackEditorSelection);
  },
  beforeUnmount() {
    document.removeEventListener("selectionchange", this.trackEditorSelection);
    this.removeImageResizeListeners();
  },
  methods: {
    setEditorHtml() {
      const sanitizedTemplate = sanitizeTemplate(this.modelValue || "");

      if (
        this.$refs.editor &&
        sanitizeTemplate(this.$refs.editor.innerHTML || "") !== sanitizedTemplate
      ) {
        this.$refs.editor.innerHTML = sanitizedTemplate;
        this.editorSelection = null;
        this.clearSelectedImage();
      }
    },
    syncContent() {
      const template = sanitizeTemplate(this.$refs.editor?.innerHTML || "");

      this.$emit("update:modelValue", template);
      this.saveEditorSelection();
    },
    saveEditorSelection() {
      const selection = window.getSelection();
      const editor = this.$refs.editor;

      if (!selection?.rangeCount || !editor) return;

      const range = selection.getRangeAt(0);

      if (editor.contains(range.commonAncestorContainer))
        this.editorSelection = range.cloneRange();
    },
    preserveEditorSelection() {
      const selection = window.getSelection();
      const editor = this.$refs.editor;

      if (!selection?.rangeCount || !editor) return;

      const range = selection.getRangeAt(0);

      if (editor.contains(range.commonAncestorContainer))
        this.editorSelection = range.cloneRange();
    },
    trackEditorSelection() {
      const editor = this.$refs.editor;
      const selection = window.getSelection();

      if (!editor || !selection?.rangeCount) return;

      const range = selection.getRangeAt(0);

      if (editor.contains(range.commonAncestorContainer))
        this.editorSelection = range.cloneRange();
    },
    handleToolbarMouseDown(event) {
      this.preserveEditorSelection();

      const target = event.target;
      if (target?.tagName === "INPUT") return;

      event.preventDefault();
    },
    restoreEditorSelection() {
      const editor = this.$refs.editor;
      const selection = window.getSelection();

      if (!editor || !selection) return false;

      editor.focus();
      selection.removeAllRanges();

      if (this.editorSelection) {
        selection.addRange(this.editorSelection);
        return true;
      }

      const range = document.createRange();
      range.selectNodeContents(editor);
      range.collapse(false);
      selection.addRange(range);
      this.editorSelection = range.cloneRange();
      return true;
    },
    insertTextAtCursor(text) {
      this.clearSelectedImage();
      this.restoreEditorSelection();

      const selection = window.getSelection();
      if (!selection?.rangeCount) return;

      const range = selection.getRangeAt(0);
      range.deleteContents();
      range.insertNode(document.createTextNode(text));
      range.collapse(false);

      selection.removeAllRanges();
      selection.addRange(range);
      this.editorSelection = range.cloneRange();
      this.syncContent();
    },
    format(command, value = null) {
      this.clearSelectedImage();
      if (!this.restoreEditorSelection()) return;
      document.execCommand(command, false, value);
      this.syncContent();
    },
    applyTextFormat(format) {
      const styles = {
        bold: { fontWeight: "bold" },
        italic: { fontStyle: "italic" },
        underline: { textDecoration: "underline" },
        strikeThrough: { textDecoration: "line-through" },
      };

      this.applyInlineStyle(styles[format] || {});
    },
    selectFontSize(value) {
      this.fontSize = Math.min(Math.max(Number(value) || 14, 4), 72);
      this.applyInlineStyle({ fontSize: `${this.fontSize}px` });
    },
    selectFontName(value) {
      this.fontName = value;
      this.applyInlineStyle({ fontFamily: value });
    },
    selectFontColor(event) {
      const color = event?.target?.value || this.fontColor;
      this.fontColor = color;
      this.applyInlineStyle({ color });
    },
    selectBackgroundColor(event) {
      const backgroundColor = event?.target?.value || this.backgroundColor;
      this.backgroundColor = backgroundColor;
      this.applyInlineStyle({ backgroundColor });
    },
    selectLineHeight(value) {
      this.lineHeight = value;
      this.applyInlineStyle({ lineHeight: value });
    },
    alignText(textAlign) {
      this.applyBlockOnlyStyle({ textAlign });
    },
    indentText() {
      this.applyBlockOnlyStyle({ marginLeft: "24px" });
    },
    selectColumnCount(value) {
      const columnCount = Math.min(Math.max(Number(value) || 1, 1), 4);

      this.columnCount = columnCount;
      this.applyColumnLayout(columnCount);
    },
    selectBorderSide(value) {
      this.borderSide = value;
      this.applyBorderStyle();
    },
    selectBorderStyle(value) {
      this.borderStyle = value;
      this.applyBorderStyle();
    },
    applyBorderStyle() {
      const side = this.borderSide === "all" ? "" : `-${this.borderSide}`;
      const style = {};
      const width = Math.max(Number(this.borderWidth) || 0, 0);

      style[`border${side}Width`] = `${width}px`;
      style[`border${side}Style`] = this.borderStyle;
      style[`border${side}Color`] = this.fontColor;

      if (this.borderStyle === "none" || width === 0) {
        style[`border${side}Width`] = "0px";
        style[`border${side}Style`] = "none";
      }

      this.applyBlockOnlyStyle(style);
    },
    applyInlineStyle(style = {}) {
      this.clearSelectedImage();
      const editor = this.$refs.editor;
      if (!editor) return;

      const range = this.editorSelection
        ? this.editorSelection.cloneRange()
        : this.createEditorEndRange();

      if (!editor.contains(range.commonAncestorContainer)) return;

      this.removeConflictingAncestorStyles(range, Object.keys(style));

      const span = document.createElement("span");
      Object.entries(style).forEach(([key, value]) => {
        span.style[key] = value;
      });

      if (range.collapsed) {
        span.appendChild(document.createTextNode("\u200b"));
        range.insertNode(span);
        range.setStart(span.firstChild, 1);
        range.collapse(true);
      } else {
        const contents = range.extractContents();

        this.removeConflictingStyles(contents, Object.keys(style));
        this.applyBlockStyles(contents, style);

        span.appendChild(contents);
        range.insertNode(span);
        range.selectNodeContents(span);
      }

      const selection = window.getSelection();
      editor.focus();
      selection.removeAllRanges();
      selection.addRange(range);
      this.editorSelection = range.cloneRange();
      this.syncContent();
    },
    applyBlockOnlyStyle(style = {}) {
      this.clearSelectedImage();
      const editor = this.$refs.editor;
      if (!editor) return;

      const range = this.editorSelection
        ? this.editorSelection.cloneRange()
        : this.createEditorEndRange();

      if (!editor.contains(range.commonAncestorContainer)) return;

      const blocks = this.getSelectedBlockElements(range);

      blocks.forEach((block) => {
        this.removeStyleProperties(block, Object.keys(style));
        Object.entries(style).forEach(([key, value]) => {
          block.style[key] = value;
        });

        if (!block.getAttribute("style")?.trim()) block.removeAttribute("style");
      });

      const selection = window.getSelection();
      editor.focus();
      selection.removeAllRanges();
      selection.addRange(range);
      this.editorSelection = range.cloneRange();
      this.syncContent();
    },
    applyColumnLayout(columnCount = 1) {
      const editor = this.$refs.editor;
      if (!editor) return;

      this.clearSelectedImage();

      const currentWrapper = this.getColumnLayoutWrapper();
      if (columnCount === 1) {
        if (currentWrapper) this.unwrapColumnLayout(currentWrapper);
        this.syncContent();
        return;
      }

      const wrapper = currentWrapper || document.createElement("div");

      wrapper.classList.add("label-columns-layout");
      wrapper.dataset.labelColumns = "true";
      wrapper.style.columnCount = String(columnCount);
      wrapper.style.columnGap = "12px";
      wrapper.style.columnFill = "auto";
      wrapper.style.width = "100%";

      if (!currentWrapper) {
        const fragment = document.createDocumentFragment();

        while (editor.firstChild) fragment.appendChild(editor.firstChild);

        wrapper.appendChild(fragment);
        editor.appendChild(wrapper);
      }

      this.syncContent();
    },
    getColumnLayoutWrapper() {
      const editor = this.$refs.editor;
      if (!editor) return null;

      const elementChildren = Array.from(editor.children || []);

      if (elementChildren.length !== 1) return null;

      const [wrapper] = elementChildren;

      return wrapper?.dataset?.labelColumns === "true" ||
        wrapper?.style?.columnCount
        ? wrapper
        : null;
    },
    unwrapColumnLayout(wrapper) {
      const editor = this.$refs.editor;
      if (!editor || !wrapper) return;

      const fragment = document.createDocumentFragment();

      while (wrapper.firstChild) fragment.appendChild(wrapper.firstChild);

      editor.insertBefore(fragment, wrapper);
      wrapper.remove();
    },
    removeConflictingStyles(root, styleKeys) {
      const elements = this.getElementNodes(root);

      elements.forEach((element) => {
        this.removeStyleProperties(element, styleKeys);
      });
    },
    removeConflictingAncestorStyles(range, styleKeys) {
      const editor = this.$refs.editor;
      const ancestors = [
        ...this.getNodeAncestors(range.startContainer),
        ...this.getNodeAncestors(range.endContainer),
      ];

      [...new Set(ancestors)].forEach((element) => {
        if (element !== editor && editor.contains(element))
          this.removeStyleProperties(element, styleKeys);
      });
    },
    removeStyleProperties(element, styleKeys) {
      const properties = this.getConflictingStyleProperties(styleKeys);

      properties.forEach((property) => element.style.removeProperty(property));

      if (!element.getAttribute("style")?.trim()) element.removeAttribute("style");
    },
    getConflictingStyleProperties(styleKeys = []) {
      const borderProperties = [
        "border",
        "border-bottom",
        "border-bottom-color",
        "border-bottom-style",
        "border-bottom-width",
        "border-color",
        "border-left",
        "border-left-color",
        "border-left-style",
        "border-left-width",
        "border-right",
        "border-right-color",
        "border-right-style",
        "border-right-width",
        "border-style",
        "border-top",
        "border-top-color",
        "border-top-style",
        "border-top-width",
        "border-width",
      ];
      const groups = {
        backgroundColor: ["background-color"],
        borderBottomColor: borderProperties,
        borderBottomStyle: borderProperties,
        borderBottomWidth: borderProperties,
        borderColor: borderProperties,
        borderLeftColor: borderProperties,
        borderLeftStyle: borderProperties,
        borderLeftWidth: borderProperties,
        borderRightColor: borderProperties,
        borderRightStyle: borderProperties,
        borderRightWidth: borderProperties,
        borderStyle: borderProperties,
        borderTopColor: borderProperties,
        borderTopStyle: borderProperties,
        borderTopWidth: borderProperties,
        borderWidth: borderProperties,
        color: ["color"],
        fontFamily: ["font-family"],
        fontSize: ["font-size"],
        fontStyle: ["font-style"],
        fontWeight: ["font-weight"],
        lineHeight: ["line-height"],
        marginLeft: ["margin-left"],
        textAlign: ["text-align"],
        textDecoration: ["text-decoration"],
      };

      return [
        ...new Set(
          styleKeys.flatMap((key) => groups[key] || [this.toCssPropertyName(key)])
        ),
      ];
    },
    applyBlockStyles(root, style = {}) {
      const blockStyleKeys = Object.keys(style).filter((key) =>
        /^(backgroundColor|lineHeight|border)/.test(key)
      );

      if (!blockStyleKeys.length) return;

      this.getElementNodes(root)
        .filter((element) => this.isBlockElement(element))
        .forEach((element) => {
          blockStyleKeys.forEach((key) => {
            element.style[key] = style[key];
          });
        });
    },
    getElementNodes(root) {
      const elements = [];

      if (root.nodeType === Node.ELEMENT_NODE) elements.push(root);
      root.querySelectorAll?.("*").forEach((element) => elements.push(element));

      return elements;
    },
    getNodeAncestors(node) {
      const ancestors = [];
      let element =
        node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;

      while (element) {
        ancestors.push(element);
        element = element.parentElement;
      }

      return ancestors;
    },
    getSelectedBlockElements(range) {
      const editor = this.$refs.editor;
      const blocks = this.getElementNodes(editor).filter(
        (element) =>
          element !== editor &&
          this.isBlockElement(element) &&
          range.intersectsNode(element)
      );

      if (blocks.length) return blocks;

      const element =
        range.commonAncestorContainer.nodeType === Node.ELEMENT_NODE
          ? range.commonAncestorContainer
          : range.commonAncestorContainer.parentElement;
      const block = element?.closest?.(
        "address,article,aside,blockquote,div,dl,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hr,li,main,nav,ol,p,pre,section,table,ul"
      );

      return block && editor.contains(block) ? [block] : [editor];
    },
    isBlockElement(element) {
      return [
        "ADDRESS",
        "ARTICLE",
        "ASIDE",
        "BLOCKQUOTE",
        "DIV",
        "DL",
        "FIELDSET",
        "FIGCAPTION",
        "FIGURE",
        "FOOTER",
        "FORM",
        "H1",
        "H2",
        "H3",
        "H4",
        "H5",
        "H6",
        "HEADER",
        "HR",
        "LI",
        "MAIN",
        "NAV",
        "OL",
        "P",
        "PRE",
        "SECTION",
        "TABLE",
        "UL",
      ].includes(element.tagName);
    },
    toCssPropertyName(key) {
      return key.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
    },
    createEditorEndRange() {
      const range = document.createRange();
      const editor = this.$refs.editor;

      range.selectNodeContents(editor);
      range.collapse(false);

      return range;
    },
    insertVariable(variable) {
      const variableValue = variable?.value || variable;

      this.insertTextAtCursor(variableValue);
    },
    selectImage() {
      this.clearSelectedImage();
      this.$refs.imageInput.click();
    },
    insertImage(event) {
      const [file] = event.target.files || [];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = () => {
        this.restoreEditorSelection();
        document.execCommand("insertImage", false, reader.result);
        this.syncContent();
        event.target.value = "";
      };
      reader.readAsDataURL(file);
    },
    handleEditorClick(event) {
      if (event.target?.tagName === "IMG") {
        this.selectedImage = event.target;
        this.updateImageResizeBox();
        return;
      }

      this.clearSelectedImage();
      this.saveEditorSelection();
    },
    updateImageResizeBox() {
      this.$nextTick(() => {
        const wrapper = this.$refs.editorWrapper;

        if (!wrapper || !this.selectedImage || !wrapper.contains(this.selectedImage)) {
          this.clearSelectedImage();
          return;
        }

        const imageRect = this.selectedImage.getBoundingClientRect();
        const wrapperRect = wrapper.getBoundingClientRect();

        this.imageResizeBox = {
          left: imageRect.left - wrapperRect.left,
          top: imageRect.top - wrapperRect.top,
          width: imageRect.width,
          height: imageRect.height,
        };
      });
    },
    clearSelectedImage() {
      this.selectedImage = null;
      this.imageResizeBox = null;
      this.imageResizeState = null;
      this.removeImageResizeListeners();
    },
    startImageResize(event) {
      if (!this.selectedImage) return;

      const imageRect = this.selectedImage.getBoundingClientRect();

      this.imageResizeState = {
        startX: event.clientX,
        startWidth: imageRect.width,
        ratio: imageRect.height / imageRect.width,
      };

      document.addEventListener("mousemove", this.resizeSelectedImage);
      document.addEventListener("mouseup", this.stopImageResize);
    },
    resizeSelectedImage(event) {
      if (!this.selectedImage || !this.imageResizeState) return;

      const width = Math.max(
        24,
        Math.round(
          this.imageResizeState.startWidth +
            event.clientX -
            this.imageResizeState.startX
        )
      );

      this.selectedImage.style.width = `${width}px`;
      this.selectedImage.style.height = "auto";
      this.selectedImage.removeAttribute("width");
      this.selectedImage.removeAttribute("height");

      const ratio = this.imageResizeState.ratio || 1;
      this.imageResizeBox = {
        ...this.imageResizeBox,
        width,
        height: Math.round(width * ratio),
      };
    },
    stopImageResize() {
      this.syncContent();
      this.updateImageResizeBox();
      this.imageResizeState = null;
      this.removeImageResizeListeners();
    },
    removeImageResizeListeners() {
      document.removeEventListener("mousemove", this.resizeSelectedImage);
      document.removeEventListener("mouseup", this.stopImageResize);
    },
  },
};
</script>

<style scoped>
.field-label {
  display: block;
  margin: 16px 0 6px;
  font-size: 13px;
  font-weight: 600;
}

.label-editor-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  margin: 12px 0 10px;
  padding: 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #f8f9fb;
}

.toolbar-section {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
  min-height: 34px;
  padding: 3px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fff;
}

.toolbar-section > * {
  flex: 0 0 auto;
}

.toolbar-section-labeled {
  gap: 6px;
  padding-left: 8px;
}

.toolbar-clear-section {
  flex: 0 0 auto;
  margin-left: auto;
}

.toolbar-label {
  flex: 0 0 auto;
  color: #606266;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  text-transform: uppercase;
}

.toolbar-section :deep(.el-button) {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 32px;
  height: 28px;
  min-height: 28px;
  padding: 0 9px;
  line-height: 28px;
  white-space: nowrap;
  vertical-align: middle;
}

.toolbar-section :deep(.el-dropdown) {
  flex: 0 0 auto;
}

.toolbar-section :deep(.el-button + .el-button) {
  margin-left: 0;
}

.toolbar-section :deep(.el-button[onlyIcon]) {
  min-width: 32px;
  width: 32px;
  padding: 0;
}

.toolbar-section :deep(.el-button i) {
  flex: 0 0 auto;
  margin-right: 4px;
  line-height: 1;
}

.toolbar-section :deep(.el-button[onlyIcon] i) {
  margin-right: 0;
}

.toolbar-section :deep(.toolbar-number-input) {
  flex: 0 0 64px;
  width: 64px !important;
  max-width: 64px;
  margin-top: 0 !important;
}

.toolbar-section :deep(.toolbar-number-input.el-input) {
  width: 64px !important;
}

.toolbar-section :deep(.el-input__inner) {
  width: 100%;
  height: 28px;
  line-height: 28px;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
}

.toolbar-section :deep(.toolbar-number-input input[type="number"]::-webkit-outer-spin-button),
.toolbar-section :deep(.toolbar-number-input input[type="number"]::-webkit-inner-spin-button) {
  margin: 0;
  appearance: none;
  -webkit-appearance: none;
}

.toolbar-section :deep(.toolbar-number-input input[type="number"]) {
  appearance: textfield;
  -moz-appearance: textfield;
}

.toolbar-symbol {
  display: inline-flex;
  min-width: 14px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 28px;
}

.toolbar-underline {
  text-decoration: underline;
}

.toolbar-strike {
  text-decoration: line-through;
}

.toolbar-color-section {
  gap: 8px;
}

.toolbar-color {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  margin: 0;
  color: #606266;
  font-size: 12px;
  line-height: 28px;
}

.toolbar-color input[type="color"] {
  width: 24px;
  height: 24px;
  padding: 0;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  background: #fff;
  cursor: pointer;
}

.image-input {
  display: none;
}

.label-editor-wrapper {
  position: relative;
}

.label-editor {
  min-height: 320px;
  padding: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  overflow: auto;
}

.image-resize-box {
  position: absolute;
  border: 1px solid #409eff;
  pointer-events: none;
  z-index: 2;
}

.image-resize-handle {
  position: absolute;
  right: -6px;
  bottom: -6px;
  width: 12px;
  height: 12px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #409eff;
  cursor: nwse-resize;
  pointer-events: auto;
}

.variables-list {
  margin-top: 8px;
}

.variable-group {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #ebeef5;
}

.variable-group-title {
  flex: 0 0 160px;
  color: #606266;
  font-size: 12px;
  font-weight: 600;
}

.variables-list .el-tag {
  cursor: pointer;
}
</style>
